/**
 * Drive Error Toast — quota-aware feedback for Drive write failures.
 *
 * If the error is a "storage quota exceeded" (403), shows an actionable
 * TOAST pointing the user to Google One storage management (critical, requires action).
 * Otherwise, routes the error to BigwaStatusPanel (non-intrusive, accumulated).
 *
 * Fase 2b Não-Intrusividade: operational Drive errors go to the panel.
 * Quota errors stay as toasts (critical, immediate user action needed).
 */
import { bigwaToast } from './bigwaToast';
import { isDriveQuotaError } from '../services/googleDrive/core';

const QUOTA_MESSAGE = 'Seu Google Drive está cheio. Libere espaço ou aumente seu armazenamento em one.google.com/storage';

export function driveErrorToast(error: unknown, fallbackMessage: string): void {
  if (isDriveQuotaError(error)) {
    bigwaToast.error(QUOTA_MESSAGE, { duration: 10000, id: 'drive-quota' });
  } else {
    bigwaToast.notify(fallbackMessage, { status: 'error' });
  }
}
